import HotelDetailsStepper from "../components/HotelDetailsStepper/HotelDetailsStepper";
import Wizard from "../components/HotelDetailsWizard/HotelDetailsWizard";
import MobileSidebarDrawer from "../components/HotelSidebar/MobileSidebarDrawer";
import CountdownTimerSlider from "../../../Components/CountdownTimerSlider/CountdownTimerSlider";

export default function HotelDetailsMob() {
  return (
    <div className="w-full! flex flex-col">
      <div className="flex w-full flex-1 items-center">
        <div className="lg:gap-30 gap-10 bg-background-default border-border-default flex w-full flex-1 items-center justify-center gap-5 justify-self-center border-b p-4">
          <div className="flex-1 md:px-40">
            <HotelDetailsStepper />
          </div>
        </div>
      </div>
      <div className="sticky top-0 z-10">
        <CountdownTimerSlider />
      </div>
      <div className="p-4 pb-24">
        <div className="flex min-w-0 flex-1 flex-col">
          <Wizard />
        </div>
      </div>
      <MobileSidebarDrawer />
    </div>
  );
}
